export class NetworkError extends Error {
  constructor(
    public request: Request,
    public parentException?: Error,
    ...params: any[]
  ) {
    super(...params);
  }

  get message() {
    if (this.parentException instanceof TypeError) {
      return "Der Server ist nicht erreichbar. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später noch einmal.";
    } else {
      return `Während einer Netzwerkanfrage ist ein Fehler aufgetreten. Die ${
        this.request.method
      } Anfrage an ${
        this.request.url
      } konnte nicht erfolgreich ausgeführt werden.`;
    }
  }
}
